<template>
	<div>
		<HeaderBar title="家族史"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="慢性乙肝">
					<StaticMulSelect label="慢性乙肝" :selectkey.sync="form.bq402.bq402003" :list="familyList" />
					<FormNormalInput label="其他" v-show="form.bq402.bq402003.indexOf('其他')!=-1"
						v-model="form.bq402.bq4020032" />
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq402.bq402003}}</span>
            <span v-show="form.bq402.bq402003=='其他'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq402.bq4020032}}
              </van-tag>
            </span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="肝硬化">
					<StaticMulSelect label="肝硬化" :selectkey.sync="form.bq402.bq402004" :list="familyList" />
					<FormNormalInput label="其他" v-show="form.bq402.bq402004.indexOf('其他')!=-1"
						v-model="form.bq402.bq4020042" />
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq402.bq402004}}</span>
            <span v-show="form.bq402.bq402004=='其他'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq402.bq4020042}}
              </van-tag>
            </span>
          </template>
        </van-cell> -->
				</van-cell-group>

				<van-cell-group title="肝癌">
					<StaticMulSelect label="肝癌" :selectkey.sync="form.bq402.bq402005" :list="familyList" />
					<FormNormalInput label="其他" v-show="form.bq402.bq402005.indexOf('其他')!=-1"
						v-model="form.bq402.bq4020052" />
					<!--        <van-cell>
          <template #title>
            <span class="followRecord-title">{{form.bq402.bq402005}}</span>
            <span v-show="form.bq402.bq402005=='其他'">
              <van-tag type="danger" class="followRecord-tag">{{form.bq402.bq4020052}}
              </van-tag>
            </span>
          </template>
        </van-cell> -->

					<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq402.guid'></FormNormalUpload>

					<div class="page-bottom-box" style="margin: 16px;">
						<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
							:editMode="form.bq402.guid!=''" class="hide">保存
						</SaveButton>
						<van-button block type="info" @click="SaveInfo">保存</van-button>
					</div>

				</van-cell-group>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../base/components.js'
	export default {
		name: "page",
		data() {
			return {
				form: {
					bq402: {

						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq001018: "", //患者编号
						bq402003: "", //慢性乙肝人员
						bq4020032: "", //其他
						bq402004: "", //肝硬化人员
						bq4020042: "", //其他
						bq402005: "", //肝癌人员
						bq4020052: "", //其他
						Bq001_018: "", //患者编号
						Bq402_003: [], //慢性乙肝人员
						Bq402_003_2: "", //其他
						Bq402_004: [], //肝硬化人员
						Bq402_004_2: "", //其他
						Bq402_005: [], //肝癌人员
						Bq402_005_2: "", //其他
					}
				},
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq402/Save',
				// 家族数组
				familyList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400')) //获取随访信息
			}
		},
		components: {
			...componentsModel,
		},
		methods: {
			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				// this.Back()
			},
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq001018: that.bq400.Bq001_018
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq402/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel,dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq402)
				}, null, null, null);
			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.$utils.CopyKeySave(that.form.bq402,that.form.bq402)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			let that = this
			// 预处理下拉数组
			that.familyList = that.$utils.setStandardList(that.$apis.s400Apis.familyList)
			that.form.bq402.bq001018 = that.bq400.bq001018
			this.LoadInfo()
			this.Resize()
		}
	}
</script>

<style scoped>
	.followRecord-title {
		padding-right: 10px;
	}

	.followRecord-tag {
		margin-right: 10px;
	}
</style>
